/** Tenant content modules (license / entitlement). Not platform SaaS ops. */
export const TENANT_MODULE_OPTIONS = [
  'CityDirectory',
  'Reports',
  'Rss',
  'Push',
  'AppTheme',
  'Parking',
  'HtmlApplets',
] as const;

export type TenantModuleCode = (typeof TENANT_MODULE_OPTIONS)[number];
